<script>
import Ajouter from '../PageForm'

export default {
  name: 'ValFlagger',
  components:{
      Ajouter,
  },
  props: ['api', 'array', 'unit'],
  data(){
      return {
        arrayFromApi: [],
        dates: [],
      }
  },
  mounted(){
    this.$axios.get(this.api)
        .then(response =>{
            this.arrayFromApi = response.data[this.array]
            this.arrayFromApi.forEach((e, i) => {
                if (e.date){
                    this.dates[i] = e.date.slice(0, 10)
                }
            });
        });
  },
  computed:{
      newDate(){
            let myDate = new Date
            let year = myDate.getFullYear()
            let month = ("0" + (myDate.getMonth() + 1)).slice(-2)
            let day = ("0" + myDate.getDate()).slice(-2)
            let stringDate = year + "-" + month + "-" + day + 'T00:00:00.000Z'
            // let stringDate = year + "-" + month + "-" + day 

            return stringDate
      }
  },
  methods: {
    updateVal(){
        let item = {}

        //La valeur est déjà à jour dans this.arrayFromApi grâce à v-model, je peux compléter mon objet et l'envoyer
        item[this.array] = this.arrayFromApi

        this.$axios.put(this.api, item)
        .then(response =>{
            console.log(response);
        })
    },
    updateDate(index, e){
        let agence = {}
        
        //Mise à jour de la date dans this.arrayFromApi
        let date = new Date

        date.setFullYear(e.target.value.slice(0, 4));
        date.setMonth(parseInt(e.target.value.slice(5, 7)) - 1);
        date.setDate(e.target.value.slice(8, 10));

        date.setUTCHours(0)
        date.setUTCMinutes(0)
        date.setUTCSeconds(0)
        date.setUTCMilliseconds(0)

        this.arrayFromApi[index].date = date;

        //Je complète mon objet et j'envoi
        agence[this.array] = this.arrayFromApi

        this.$axios.put(this.api, agence)
        // .then(response =>{
        //     console.log(response);
        // })
    },
    addVal(payload){
        let agence = {}
        let date = new Date

        date.setFullYear(payload[0].slice(0, 4));
        date.setMonth(parseInt(payload[0].slice(5, 7)) - 1);
        date.setDate(payload[0].slice(8, 10));

        date.setUTCHours(0)
        date.setUTCMinutes(0)
        date.setUTCSeconds(0)
        date.setUTCMilliseconds(0)

        date = date.toISOString();
console.log(date)
        this.arrayFromApi.push({date: date, val: parseFloat(payload[1])})
        //Pour finir, je range le items dans l'ordre avant de renvoyer le nouvel objet au server
        this.arrayFromApi.sort((a,b) => (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0));
        //Et je mets à jour mes dates
        this.arrayFromApi.forEach((e, i) => {
            if (e.date){
                this.dates[i] = e.date.slice(0, 10)
            }
        });

        agence[this.array] = this.arrayFromApi
        this.$axios.put(this.api, agence)
    },
  },
}
</script>
          

<template>
  <div v-if="arrayFromApi.length" class="valFlagger">
    <div class="liste">
        <div v-for="(item, index) in arrayFromApi" :key="index" class="liste__line">
            <div class="liste__line__date" v-if="index === 0">Valeur initiale :</div>
            <div class="liste__line__date" v-else>
                <input type="date" class="liste__line__date__input" v-model="dates[index]" @change="updateDate(index, $event)">
            </div>
            <div class="liste__line__result">
                <input type="number" step="0.01" min="0" class="liste__line__result__val" v-model="arrayFromApi[index].val" @change="updateVal()" />
                <span class="liste__line__result__unit"> {{unit}} </span>
            </div>
        </div>
    </div>
    <Ajouter label="Nouvelle valeur à partir du : " labelSize=12 icon="add_circle" @submit="addVal($event)">
        <template v-slot:body>
            <input type="date" :value="newDate" class="formDate"/>
            <input type="number" step="0.01" min="0" class="liste__line__result__val formVal" />
        </template>
    </Ajouter>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.valFlagger{
    width: 100%;
}

.liste{
    @include myFont;
    @include myBlock;
    font-size: 13px;
    padding: 7px;
    margin: 0 0 15px 0;

    &__line{
        display: flex;
        justify-content: space-between;
        margin: 0 0 3px 0;

        &__date{

            & input{
                border: none;
                margin: 0 10px 0 0;
            }
        }

        &__result{

            &__val{
                width: 60px;
                text-align: right;
                padding: 0 2px 0 0;
                border: none;
                border-bottom: 1px solid $main;

                // Supprimer les flèches du type Number
                -moz-appearance: textfield;
                &::-webkit-inner-spin-button{
                    -webkit-appearance: none;
                    margin: 0;
                }
            }
        }
    }
}

.form{
    &Date{
        margin: 0 5px 0 0;
    }
}

</style>
